<!--<p-toggleButton [(ngModel)]="showAgents" onLabel="Show Agents" offLabel="Hide Agents" (onChange)="toggleAgents()"></p-toggleButton>-->


<div id="map"></div>

<p-dialog header="Marker Information" [(visible)]="displayDialog" [modal]="true" [closable]="true" [dismissableMask]="true" [style]="{width: '300px'}">
<!--    <p>{{ selectedMarkerInfo | json }}</p>-->
</p-dialog>
